import jsPDF from "jspdf";
import "jspdf-autotable";
import { format } from 'date-fns';
// Date Fns is used to format the dates we receive
// from our API call

// define a generatePDF function that accepts a tickets argument

//https://www.freecodecamp.org/news/how-to-create-pdf-reports-in-react/
const generateReporteEstudiantesPDF = (estudiantes) => {
    // initialize jsPDF
    const doc = new jsPDF();

    // define the columns we want and their titles
    const tableColumn = [
        "Nro",
        "Id",
        "Nombres",
        "Agenda",
        "Telefono",
        "Especialidad",
        "Ultimo Comentario",
    ];
    // define an empty array of rows
    const tableRows = [];

    // for each ticket pass all its data into an array
    let i = 0;
    estudiantes.sort((a, b) =>
        a.cli_apellido > b.cli_apellido
            ? 1
            : b.cli_apellido > a.cli_apellido
                ? -1
                : 0
    );

    estudiantes.forEach((estudiante) => {
        i += 1;
        let dateTemp = new Date(estudiante.fecha_agenda);
        if (dateTemp == 'Invalid Date')
            dateTemp = 'fecha incorrecta'
        else
            dateTemp = format(dateTemp.setDate(dateTemp.getDate() + 1), "MMM dd, yyyy")
        const estudianteData = [
            i,
            estudiante.cli_id,
            estudiante.cli_apellido + ' ' + estudiante.cli_nombre,
            dateTemp,
            estudiante.cli_telefono,
            estudiante.esp_nombre,
            estudiante.comentario,
        ];
        // push each tickcet's info into a row
        tableRows.push(estudianteData);
    });

    // startY is basically margin-top
    doc.text("Reporte estudiantes", 14, 15);
    doc.autoTable(tableColumn, tableRows, { startY: 20, theme: "grid" });
    doc.save(`reporte_estudiantes_${new Date().toLocaleDateString()}.pdf`);
};

export default generateReporteEstudiantesPDF;
